import { render, staticRenderFns } from "./videoModal.vue?vue&type=template&id=25dc1082&"
import script from "./videoModal.vue?vue&type=script&lang=js&"
export * from "./videoModal.vue?vue&type=script&lang=js&"
import style0 from "./videoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports